import { Phone } from "lucide-react";
import Reveal from "./Reveal";
import { SITE, ABOUT_VALUES } from "@/data/content";
import { WhatsAppIcon } from "./WhatsAppIcon";

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white border-y border-border" data-testid="about-section">
      <div className="container-luxe grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal y={40} className="relative" data-testid="about-founder-portrait">
          <div className="clip-frame overflow-hidden">
            <img
              src={SITE.aboutImage}
              alt="Illustrative aerial view of a planned smart city at dusk — the vision of Dholera Smart City, Gujarat"
              loading="lazy"
              className="w-full h-[440px] lg:h-[560px] object-cover img-treatment"
            />
          </div>
          <div className="absolute -bottom-8 -right-2 sm:right-8 glass-light shadow-deep px-8 py-6 rounded-sm max-w-xs">
            <p className="font-serif text-4xl text-gold font-semibold leading-none">SA</p>
            <p className="mt-3 font-serif text-xl text-navy font-semibold">Sunil Aggarwal</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-body mt-1">Founder · Paras Real Estate</p>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="eyebrow mb-4">About Us</p>
            <h2 className="font-serif font-semibold text-navy text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              About Paras Real Estate
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-body leading-relaxed text-base sm:text-lg">
              Paras Real Estate, led by <strong className="text-navy font-semibold">Sunil Aggarwal</strong>, helps buyers and investors explore property opportunities in and around Dholera Smart City, Gujarat. From residential plots to commercial and industrial land, we focus on clear information, genuine guidance and a smooth enquiry-to-purchase experience.
            </p>
          </Reveal>

          <div className="mt-10 space-y-6">
            {ABOUT_VALUES.map((v, i) => (
              <Reveal key={v.title} delay={0.08 * i} className="flex gap-5 items-start group">
                <span className="font-mono text-gold text-sm pt-1 border-t-2 border-gold/40 group-hover:border-gold transition-colors duration-300">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="font-serif text-xl text-navy font-semibold">{v.title}</h3>
                  <p className="text-body text-sm leading-relaxed mt-1">{v.body}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-4" data-testid="about-founder-quote">
            <a href={SITE.phoneHref} data-testid="about-call-button" className="btn-navy">
              <Phone className="w-4 h-4" /> Talk to Sunil Aggarwal
            </a>
            <a
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-whatsapp-button"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold border border-[#25D366] text-[#128C4B] transition-colors duration-300 hover:bg-[#25D366] hover:text-white"
            >
              <WhatsAppIcon /> WhatsApp Us
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
